export const ADVENT_PRIZES = [
  "Mikrobiomtest im Wert von 180 € + Erstgespräch in der PRAXIS IB im Wert von 139 €",
  "Kostenloses Zoom-Gespräch mit Isabella",
  "2× Manuka-Honig",
  "2× Shop-Apotheke-Gutschein à 40 €",
  "5× das Buch „Seelenbalance“",
];

/** Individual prizes for the raffle draw (11 total). */
export const ADVENT_PRIZE_LIST = [
  "Mikrobiomtest (180 €) + Erstgespräch in der PRAXIS IB (139 €)",
  "Kostenloses Zoom-Gespräch",
  "Manuka-Honig", "Manuka-Honig",
  "Shop-Apotheke-Gutschein (40 €)", "Shop-Apotheke-Gutschein (40 €)",
  "Buch „Seelenbalance“", "Buch „Seelenbalance“", "Buch „Seelenbalance“", "Buch „Seelenbalance“", "Buch „Seelenbalance“",
];

/** Highest door number open on the given date in Vienna (0 before Dec 1). */
export const adventOpenDay = (now: Date): number => {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Vienna", month: "numeric", day: "numeric" }).formatToParts(now);
  const month = Number(parts.find((p) => p.type === "month")?.value);
  const day = Number(parts.find((p) => p.type === "day")?.value);
  return month === 12 ? Math.min(24, day) : 0;
};

/** Show the home-page hint from now until Dec 24 (Vienna). */
export const showAdventHint = (now: Date) => {
  const m = Number(new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Vienna", month: "numeric" }).format(now));
  return m === 10 || m === 11 || adventOpenDay(now) > 0;
};
